import { useState } from "react";
import "./styles.scss";
import ConfirmAlert from "components/ConfirmAlert";
import { Button } from "semantic-ui-react";
import { useT } from "i18n";

interface RestoreScanButtonProps {
  onSubmit: () => void;
}

export default function RestoreScanButton({ onSubmit }: RestoreScanButtonProps) {
  const t = useT();
  const [isConfirmScanRejectModalOpen, setIsConfirmScanRejectModalOpen] =
    useState(false);

  return (
    <>
      <ConfirmAlert
        description={t(
          "component.restoreScanButton.confirmRestoreDescription",
          "Are you sure you want to restore the scan for this quote? Users will be able to submit quotes again.",
        )}
        isOpen={isConfirmScanRejectModalOpen}
        onClose={() => {
          setIsConfirmScanRejectModalOpen(false);
        }}
      >
        <div style={{ display: "flex", gap: "6px" }}>
          <Button
            basic
            content={t("component.common.no", "No")}
            onClick={() => {
              setIsConfirmScanRejectModalOpen(false);
            }}
          />

          <Button
            primary
            content={t("component.common.yes", "Yes")}
            onClick={() => {
              onSubmit();
              setIsConfirmScanRejectModalOpen(false);
            }}
          />
        </div>
      </ConfirmAlert>
      <button
        className={"unreject-scan-button"}
        onClick={() => {
          setIsConfirmScanRejectModalOpen(true);
        }}
      >
        {t("component.restoreScanButton.restoreRejection", "Restore Rejection")}
      </button>
    </>
  );
}
